import { NETWORK_EMOTES, type NetworkEmote } from '../../network/contracts';
import type { PeerChannel } from '../../network/webrtc-peer';
import { requireElement } from '../dom';

const ICONS: Readonly<Record<NetworkEmote, string>> = {
  'thumbs-up': '👍',
  'well-played': '👏',
  wow: '😮',
  laugh: '😂',
  oops: '😅',
  'good-luck': '⚔️',
};

/** Presentation-only P2P reactions. Emotes never enter BattleEngine, replay or checksums. */
export class NetworkPresentationController {
  private readonly bar = requireElement<HTMLElement>('#emoteBar');
  private readonly bubble = requireElement<HTMLElement>('#emoteBubble');
  private readonly overlay = requireElement<HTMLElement>('#networkOverlay');
  private readonly overlayStatus = requireElement<HTMLElement>('#networkOverlayStatus');
  private peer: PeerChannel | null = null;
  private unsubscribeEmote: (() => void) | null = null;
  private lastSentAt = 0;
  private bubbleTimer: number | null = null;

  constructor() {
    for (const button of this.bar.querySelectorAll<HTMLButtonElement>('[data-emote]')) {
      button.addEventListener('click', () => {
        const emote = button.dataset.emote;
        if (!this.peer || !NETWORK_EMOTES.includes(emote as NetworkEmote) || Date.now() - this.lastSentAt < 1_000) return;
        this.lastSentAt = Date.now();
        this.peer.sendEmote(emote as NetworkEmote);
        this.show(emote as NetworkEmote);
      });
    }
  }

  attach(peer: PeerChannel): void {
    this.detach();
    this.peer = peer;
    this.bar.hidden = false;
    this.unsubscribeEmote = peer.onEmote((emote) => this.show(emote));
  }

  detach(): void {
    this.unsubscribeEmote?.();
    this.unsubscribeEmote = null;
    this.peer = null;
    this.bar.hidden = true;
    this.overlay.hidden = true;
    this.bubble.hidden = true;
  }

  connectionStatus(message: string | null): void {
    this.overlayStatus.textContent = message ?? '';
    this.overlay.hidden = message === null;
  }

  private show(emote: NetworkEmote): void {
    if (this.bubbleTimer !== null) window.clearTimeout(this.bubbleTimer);
    this.bubble.textContent = ICONS[emote];
    this.bubble.hidden = false;
    this.bubble.style.animation = 'none';
    void this.bubble.offsetWidth;
    this.bubble.style.animation = '';
    this.bubbleTimer = window.setTimeout(() => { this.bubble.hidden = true; }, 1_800);
  }
}
